export default __webpack_public_path__ + "static/media/038-turn left.3517acec.png";